import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDatabase12Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 80 80"
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#666"
        d="M75 6a1 1 0 0 1 1 1v21a.995.995 0 0 1-.134.5.993.993 0 0 1 .134.5v21a.995.995 0 0 1-.134.501A.982.982 0 0 1 76 51v21a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V51c0-.182.049-.353.134-.5A.993.993 0 0 1 4 50V29c0-.182.049-.353.134-.5A.993.993 0 0 1 4 28V7a1 1 0 0 1 1-1Zm0 45H5v21h70V51Zm0-22H5v21h70V29Zm0-22H5v21h70V7Z"
      />
      <path
        fill="#BFBFBF"
        d="M64 59v5H48v-5h16Zm0-22v5H48v-5h16Zm0-22v5H48v-5h16Z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgDatabase12Px);
export default Memo;
